import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-538d68a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-message" }
const _hoisted_2 = {
  key: 0,
  class: "notice-error",
  role: "alert"
}
const _hoisted_3 = { class: "notice-actions" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: !!_ctx.notice && _ctx.canPresent,
    title: "系统通知",
    width: 360,
    footer: null,
    centered: "",
    "mask-closable": false,
    "wrap-class-name": "important-notice-shell",
    "mask-style": {background:'rgba(23,35,56,.22)'},
    onCancel: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.notice?.message), 1),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "关闭"),
        _createElementVNode("button", {
          type: "button",
          class: "notice-view",
          disabled: _ctx.opening,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.view && _ctx.view(...args)))
        }, _toDisplayString(_ctx.opening?'打开中…':'查看'), 9, _hoisted_4)
      ])
    ]),
    _: 1
  }, 8, ["visible", "mask-style", "onCancel"]))
}